import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useEffect } from "react";

export default function useAlert() {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  function addAlert(alert) {
    const copyState = [...alerts];

    copyState.push(alert);

    setAlerts(copyState);

    handleClick();

    setTimeout(() => {
      const copyState = [...alerts];

      copyState.splice(0, 1);

      setAlerts(copyState);
    }, 10000);
  }

  useEffect(() => {
    // console.log("alerts", alerts);
  }, [alerts]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  function Feedback() {
    return alerts ? (
      <Stack spacing={2} sx={{ width: "100%" }}>
        {alerts?.map((item) => (
          <Snackbar open={open} autoHideDuration={3000}>
            <MuiAlert
              elevation={6}
              variant="filled"
              onClose={handleClose}
              severity={item.severity}
              sx={{ width: "100%" }}
            >
              {item.message}
            </MuiAlert>
          </Snackbar>
        ))}
      </Stack>
    ) : null;
  }

  return [addAlert, Feedback];
}
